import * as React from 'react';
import PropTypes from 'prop-types';

import { Icon } from 'antd';

import RoleItem from './RoleItem';
import RoleSelector from './RoleSelector';

import s from './style/Roles.pcss';


export default class Roles extends React.Component {
  static propTypes = {
    roles: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    onRoleSelect: PropTypes.func.isRequired,
    onCreateRole: PropTypes.func.isRequired,
    onEditRole: PropTypes.func.isRequired,
    onRemoveRole: PropTypes.func.isRequired,
    saving: PropTypes.bool.isRequired,
    selectedRole: PropTypes.string,
  };

  state = {
    addMode: false,
  };

  static defaultProps = {
    selectedRole: '',
  };

  componentDidMount() {
    document.addEventListener('mousedown', this.onHandleBlur);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.onHandleBlur);
  }

  setRef = (ref) => {
    this.btnContainer = ref;
  };

  onHandleBlur = (e) => {
    if (this.btnContainer && !this.btnContainer.contains(e.target)) {
      this.onSetAddMode(false);
    }
  };

  onSetAddMode = addMode => this.setState({ addMode });
  onCreateRole = (name) => {
    const body = {
      name,
      status: 'role_status_add',
    };
    return this.props.onCreateRole(body).then(() => {
      this.setState({ addMode: false });
    });
  };

  render() {
    const { addMode } = this.state;
    const { saving } = this.props;
    return (
      <div className={s.roles}>
        <div className={s.list}>
          {this.props.roles.map(role => (
            <RoleItem
              key={role.id}
              saving={saving}
              selected={role.id === this.props.selectedRole}
              item={role}
              onRoleSelect={this.props.onRoleSelect}
              onRemoveRole={this.props.onRemoveRole}
              onEditRole={this.props.onEditRole}
            />
          ))}
        </div>
        <div ref={this.setRef} className={s.addOverlayContainer}>
          <div className={s.addContainer} onClick={() => this.onSetAddMode(true)}>
            <Icon type="plus" theme="outlined" />
            <div className={s.addBtn}>Создать роль</div>
          </div>
          {addMode && <RoleSelector onEditRole={this.onCreateRole} />}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Root/pages/Roles/Sidebar/Roles.js